import { faClock, faCheckCircle, faTimesCircle, faCircleNotch } from '@fortawesome/free-solid-svg-icons';

export const entryStatuses = [
  { name: 'Заплановано', key: 'scheduled', icon: faClock },
  { name: 'Відбувається', key: 'running', icon: faCircleNotch },
  { name: 'Завершено', key: 'completed', icon: faCheckCircle },
  { name: 'Скасовано', key: 'cancelled', icon: faTimesCircle },
];
